import React, { useEffect, useRef, useState } from 'react';
import Loader from '../../common/Loader';
import { useFetchMatchMacrogruppo } from '../../data/fetchMatchMacrogruppo';
import { getPrincipaleOPrimoMacroGruppo } from '../../data/utils';
import CompetitionMacrogruppo from './CompetitionMacrogruppo';

export const PrematchCompetitionContext = React.createContext(null);

function findMacrogruppo(macrogruppi, id) {
    return macrogruppi.find(mg => mg.id === id);
}

function PrematchHomeCompetitionMacrogruppo(props) {
    let [showLoader, setShowLoader] = useState(true);
    const firstRender = useRef(true);

    let initState = (() => {
        if (firstRender.current === true) {
            firstRender.current = false;
        } else {
            return;
        }

        let favorites = localStorage.getItem('favorite_markets');
        if (favorites != null) {
            favorites = JSON.parse(favorites);
        } else {
            favorites = {};
        }

        if (favorites[props.match.sportRef] !== undefined) {
            const macroAll = props.macrogruppi.find(mg => mg.id < 0);
            return {
                data: null,
                match: null,
                matchFetch: props.match,
                macrogruppi: props.macrogruppi,
                macrogruppo: null,
                macrogruppoFetch: macroAll,
                forceReload: false,
                landOnFavorites: true,
                setFavoritesAsSelected: true,
                favoritesSelected: false,
                favorites
            };
        } else {
            return {
                data: null,
                match: null,
                matchFetch: props.match,
                macrogruppi: props.macrogruppi,
                macrogruppo: null,
                macrogruppoFetch: props.match.openMacrogruppo ? findMacrogruppo(props.macrogruppi, props.match.openMacrogruppo) : props.match.macrogruppi[0],
                forceReload: false,
                landOnFavorites: false,
                setFavoritesAsSelected: false,
                favoritesSelected: false,
                favorites
            };
        }
    })();

    const [state, setState] = useState({
        ...initState,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setData(data) {
            let macrogruppo = this.macrogruppoFetch;
            if (macrogruppo.aggregate.length === 0) {
                macrogruppo = findMacrogruppo(data.macrogruppi, this.matchFetch.openMacrogruppo) || getPrincipaleOPrimoMacroGruppo(data.macrogruppi);
            }
            if (this.setFavoritesAsSelected) {
                // I check whether there's any bets matching the favorite markets
                const favorites = data.scommesse.filter(bet => {
                    return this.isMarketFavorite(this.matchFetch.sportRef, bet.id + '_' + bet.handicap) && bet.hasOdds;
                });
                // If there are none, I show to the main bet group as selected by filtering only the bets that don't belong to it
                if (this.landOnFavorites && favorites.length === 0) {
                    const macrogruppo = this.macrogruppi.find(mg => mg.isPrincipale) || this.macrogruppi[0];
                    const mainGroupBets = new Set();
                    macrogruppo.aggregate.forEach(ag => {
                        ag.scommesse.forEach(bet => mainGroupBets.add(bet.id));
                    });
                    data.scommesse = data.scommesse.filter(bet => mainGroupBets.has(bet.id));
                    this.update({data, match: this.matchFetch, macrogruppo, landOnFavorites: false, setFavoritesAsSelected: false, favoritesSelected: false});
                } else {
                    this.update({data, match: this.matchFetch, macrogruppo, landOnFavorites: false, setFavoritesAsSelected: false, favoritesSelected: true});
                }
            } else {
                this.update({data, match: this.matchFetch, macrogruppo, landOnFavorites: false, setFavoritesAsSelected: false, favoritesSelected: false});
            }
        },
        changeMatch(matchFetch, macrogruppi) {
            if (this.showFavoritesForSport(matchFetch.sportRef)) {
                const macrogruppoFetch = macrogruppi.find(mg => mg.id < 0);
                this.update({macrogruppi, matchFetch, macrogruppoFetch, landOnFavorites: true, setFavoritesAsSelected: true});
            } else {
                const macrogruppoFetch = findMacrogruppo(macrogruppi, matchFetch.openMacrogruppo)
                this.update({macrogruppi, matchFetch, macrogruppoFetch});
            }
        },
        changeMacrogruppo(macrogruppoFetch) {
            if (macrogruppoFetch.id !== this.macrogruppo.id) {
                if (macrogruppoFetch.id === this.macrogruppoFetch.id) {
                    this.update({forceReload: !this.forceReload});
                } else {
                    this.update({macrogruppoFetch});
                }
            } else if (this.favoritesSelected) {
                this.update({favoritesSelected: false});
            }
        },
        selectFavorites() {
            const betGroupAll = this.macrogruppi.find(mg => mg.id < 0);
            if (betGroupAll.id === this.macrogruppoFetch.id) {
                this.update({setFavoritesAsSelected: true, macrogruppoFetch: betGroupAll, forceReload: !this.forceReload});
            } else {
                this.update({setFavoritesAsSelected: true, macrogruppoFetch: betGroupAll});
            }
        },
        toggleFavorite(sportId, betId) {
            if (this.favorites[sportId] === undefined) {
                this.favorites[sportId] = {};
                this.favorites[sportId][betId] = true;
            } else {
                if (this.favorites[sportId][betId] === undefined) {
                    this.favorites[sportId][betId] = true;
                } else {
                    delete this.favorites[sportId][betId];
                    if (Object.keys(this.favorites[sportId]).length === 0) {
                        delete this.favorites[sportId];
                    }
                }
            }
            if (Object.keys(this.favorites).length > 0) {
                if (this.favorites[sportId] === undefined) {
                    const primoMacrogruppo = findMacrogruppo(this.macrogruppi, this.match.openMacrogruppo);
                    this.update({favorites: {...this.favorites}, favoritesSelected: false, macrogruppo: primoMacrogruppo});
                } else {
                    this.update({favorites: {...this.favorites}});
                }
                localStorage.setItem('favorite_markets', JSON.stringify(this.favorites));
            } else {
                const primoMacrogruppo = findMacrogruppo(this.macrogruppi, this.match.openMacrogruppo);
                this.update({favorites: {}, favoritesSelected: false, macrogruppo: primoMacrogruppo});
                localStorage.removeItem('favorite_markets');
            }
        },
        showFavoritesForSport(sportId) {
            return this.favorites[sportId] !== undefined;
        },
        isMarketFavorite(sportId, betId) {
            return this.favorites[sportId] !== undefined && this.favorites[sportId][betId] !== undefined;
        }
    });

    function changeMacrogruppo(mg) {
        state.changeMacrogruppo(mg);
    }

    useEffect(function() {
        if (state.data != null) {
            state.changeMatch(props.match, props.macrogruppi);
        }
    }, [props.match]);

    const [request] = useFetchMatchMacrogruppo(state.matchFetch, state.macrogruppoFetch.id, state.matchFetch.isLive, state.forceReload);

    useEffect(function() {
        if (!request.isLoading) {
            if (showLoader) {
                setShowLoader(false);
            }
            if (!request.isError) {
                state.setData(request.data);
            }
        }
    }, [request]);

    return (
        <PrematchCompetitionContext.Provider value={state}>
            {showLoader || request.isError || state.macrogruppo == null ?
                <Loader error={request.isError} />
                :
                <CompetitionMacrogruppo {...state.match} {...state.data} macrogruppo={state.macrogruppo} setMacrogruppo={changeMacrogruppo} />
            }
        </PrematchCompetitionContext.Provider>
    );
}
            
export default PrematchHomeCompetitionMacrogruppo;